import { z } from 'zod';

export const PurposeSchema = z.object({
  BILL: z.literal('BILL'),
  GOODS: z.literal('GOODS'),
  OTHER: z.literal('OTHER'),
  SERVICES: z.literal('SERVICES'),
});
